/**
 * @freesewing/plugin-i18n | v2.17.1
 * A FreeSewing plugin for pattern translation
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var name = "@freesewing/plugin-i18n";
var version = "2.17.1";

var index = {
  name: name,
  version: version,
  hooks: {
    preRender: function (svg) {
      if (svg.attributes.get('freesewing:plugin-i18n') === false) {
        svg.attributes.set('freesewing:plugin-i18n', version);
      }
    },
    insertText: function (locale, text, data) {
      if (data === false) {
        console.log(
          "No data was passed to the i18n plugin. This plugin won't do much without injecting data into it"
        );
        return text
      }
      let prefix = data.prefix || '';
      if (typeof data.strings[locale][prefix + text] === 'undefined') return text
      else return data.strings[locale][prefix + text]
    },
  },
};

export default index;
//# sourceMappingURL=index.mjs.map
